export default __webpack_public_path__ + "static/media/jiologo.14858f77.svg";